var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.user_data),callback:function ($$v) {_vm.user_data=$$v},expression:"user_data"}}),_c('div',{attrs:{"id":"userAdminTablePaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }